import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastForward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFastForward"><Path d="M4 4V20L12 14V20L22.6667 12L12 4V10L4 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFastForward;
